import { EntityModel } from '@/interfaces'
import {
  ALL_SLIDER_BLOCKS_QUERY,
  CREATE_SLIDER_BLOCK_MUTATION,
  DELETE_SLIDER_BLOCK_MUTATION,
  FORCE_DELETE_SLIDER_BLOCK_MUTATION,
  SINGLE_SLIDER_BLOCK_QUERY,
  UPDATE_SLIDER_BLOCK_MUTATION,
} from './graphql'
import imageGalleryEntity from '@/entities/imageGallery/entity'

const cmsSliderBlockModel: EntityModel = {
  name: 'sliderBlock',
  namePlural: 'sliderBlocks',
  uniqueName: 'cmsSliderBlock',
  uniqueNamePlural: 'cmsSliderBlocks',
  path: 'cms/blocks/slider_block',
  baseUrl: '/cms/blocks/slider_blocks',
  translationPrefix: 'entities:cmsSliderBlock.',
  getDisplayName: (values: any) => {
    return 'Slider Block'
  },
  gql: {
    getAll: ALL_SLIDER_BLOCKS_QUERY,
    getSingle: SINGLE_SLIDER_BLOCK_QUERY,
    create: CREATE_SLIDER_BLOCK_MUTATION,
    update: UPDATE_SLIDER_BLOCK_MUTATION,
    delete: DELETE_SLIDER_BLOCK_MUTATION,
    forceDelete: FORCE_DELETE_SLIDER_BLOCK_MUTATION,
  },
  attributes: {
    fluid: {
      name: 'fluid',
      label: 'entities:cmsSliderBlock.attributes.fluid.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: false,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    gallery: {
      name: 'gallery',
      label: 'entities:cmsSliderBlock.attributes.gallery.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return imageGalleryEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    size: {
      name: 'size',
      label: 'entities:cmsSliderBlock.attributes.size.label',
      type: 'value',
      dataType: 'string',
      defaultValue: 'default',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsSliderBlock.attributes.size.selectOptions.default.label',
          value: 'default',
        },
        {
          label: 'entities:cmsSliderBlock.attributes.size.selectOptions.small.label',
          value: 'small',
        },
      ],
      validationType: 'string',
      validations: [],
    },
    showDots: {
      name: 'showDots',
      label: 'entities:cmsSliderBlock.attributes.showDots.label',
      type: 'value',
      dataType: 'boolean',
      defaultValue: true,
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    showArrows: {
      name: 'showArrows',
      label: 'entities:cmsSliderBlock.attributes.showArrows.label',
      type: 'value',
      dataType: 'boolean',
      defaultValue: true,
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    showLightbox: {
      name: 'showLightbox',
      label: 'entities:cmsSliderBlock.attributes.showLightbox.label',
      type: 'value',
      dataType: 'boolean',
      defaultValue: true,
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
    autoplay: {
      name: 'autoplay',
      label: 'entities:cmsSliderBlock.attributes.autoplay.label',
      type: 'value',
      dataType: 'boolean',
      defaultInput: true,
      inputType: 'switch',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsSliderBlockModel
